<template>
  <div>
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="finalRowData"
      style="width:100%;height:200px;margin-bottom: 5px"
      @gridReady="params=>gridApi=params.api"
    />
    <div v-show="isEdit" style="width:100%">
      <div style="text-align:right;margin-bottom:5px">
        <el-button v-show="showExcelButton" no="DownloadTemplate" type="primary" @click="downTemplateBtn_clickHandler">{{ $t('SeaExport.DownloadTemplate') }}</el-button>
        <el-upload
          v-show="showExcelButton"
          :action="URL.seaExport.bulkDataImportExcel"
          :headers="{ sessionId: user.sessionId }"
          :show-file-list="false"
          accept=".xls, .xlsx"
          :before-upload="beforeUpload"
          :on-success="uploadSuccess"
          style="display: inline-block; margin-left: 5px;margin-right: 5px;"
        >
          <el-button
            slot="trigger"
            type="primary"
          >{{ $t('SeaExport.ExcelImport') }}</el-button>
        </el-upload>
        <el-button no="Add" type="primary" @click="add">{{ $t('SeaExport.Add') }}</el-button>
        <el-button no="Delete" type="danger" @click="remove">{{ $t('SeaExport.Delete') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import { CargoBulkDetail } from '@/class/model/booking/CargoBulkDetail'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'

export default {
  name: 'BookingBulkDataGrid',
  components: { },
  props: {
    value: { type: Array, default: () => [] },
    jobUuid: { type: String, default: '' },
    isEdit: { type: Boolean, required: true },
    showExcelButton: { type: Boolean, required: false, default: true },
    context: { type: Object, required: true }
  },
  data() {
    return {
      URL,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: true,
        rowHeight: 32,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.Pieces'),
          field: 'insideQuantity',
          width: 85,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'el-input-number',
            precision: 0,
            valueChanged: this.caculateCubage
          }
        },
        {
          headerName: this.$t('SeaExport.Dimension'),
          field: '',
          width: 220,
          cellRendererFramework: 'agGridColumnEditGroup',
          custom: {
            isEdit: false,
            childs: [
              {
                field: 'sizeLength',
                tag: 'el-input-number',
                precision: 0,
                valueChanged: this.caculateCubage
              },
              {
                tag: 'span',
                attrs: {
                  style: 'font-size:18px;line-height:32px'
                },
                text: '*'
              },
              {
                field: 'sizeWidth',
                tag: 'el-input-number',
                precision: 0,
                valueChanged: this.caculateCubage
              },
              {
                tag: 'span',
                attrs: {
                  style: 'font-size:18px;line-height:32px'
                },
                text: '*'
              },
              {
                field: 'sizeHeight',
                tag: 'el-input-number',
                precision: 0,
                valueChanged: this.caculateCubage
              }
            ]
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage2'),
          field: 'cubage',
          width: 80,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'span'
          }
        },
        {
          headerName: this.$t('SeaExport.Weight2'),
          field: 'weight',
          width: 90,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'el-input-number'
          }
        }
      ],
      rowData: [],
      gridApi: null
    }
  },
  computed: {
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    },
    user() {
      return this.context.user || {}
    }
  },
  watch: {
    value(newVal) {
      this.rowData = newVal
    },
    isEdit(newVal) {
      for (const item of this.columnDefs) {
        if (item.custom instanceof Object) {
          item.custom.isEdit = this.isEdit
        }
      }
    }
  },
  created() {
    this.rowData = this.value
    for (const item of this.columnDefs) {
      if (item.custom instanceof Object) {
        item.custom.isEdit = this.isEdit
      }
    }
  },
  methods: {
    caculateCubage(params) {
      const data = params.data
      const cubage = (data.insideQuantity || 0) * (data.sizeLength || 0) * (data.sizeWidth || 0) * (data.sizeHeight || 0)
      data.cubage = (cubage / 1000000).toFixed(3)
    },
    add() {
      const row = new CargoBulkDetail().fillDefaultValue().getData()
      row.insideQuantity = 1
      row.jobUuid = this.jobUuid
      this.rowData.push(row)
      this.$nextTick(() => {
        this.gridApi.deselectAll()
        const nodes = this.gridApi.getRenderedNodes()
        const lastNode = nodes[nodes.length - 1]
        lastNode.setSelected(true)
      })
    },
    downTemplateBtn_clickHandler() {
      const fileName = 'SeaEqImportTemplate.xlsx'
      const folderName = 'container'
      ExportUtils.downloadTemplateFile(fileName, folderName)
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        this.onImportSucceeded(response.data)
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    //  excel 导入后逻辑处理
    onImportSucceeded(data) {
      if (data && data.length > 0) {
        let cubage = 0
        for (const item of data) {
          item.jobUuid = this.jobUuid
          cubage = (item.insideQuantity || 0) * (item.sizeLength || 0) * (item.sizeWidth || 0) * (item.sizeHeight || 0)
          item.cubage = (cubage / 1000000).toFixed(3)
          this.rowData.push(item)
        }
      }
    },
    remove() {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      const cell = this.gridApi.getFocusedCell()
      const row = cell && nodes[cell.rowIndex] ? nodes[cell.rowIndex].data : null
      if (row) {
        if (row.uuid) {
          row.deleted = true
          /* 强制刷新finalRowData */
          const tempRowData = this.rowData
          this.rowData = []
          this.$nextTick(() => {
            this.rowData = tempRowData
          })
        } else {
          const index = this.rowData.findIndex(p => p === row)
          if (index > -1) {
            this.rowData.splice(index, 1)
          }
        }
      }
    }
  }
}
</script>

<style>
</style>
